import {
    MenuItem as MuiMenuItem,
    styled,
    Menu as MuiMenu
} from '@mui/material';
import { staticColors } from '@/lib/theme';

export const MenuItem = styled(MuiMenuItem)`
    &:hover {
        background-color: ${() => staticColors.dropdownSelectedBackground};
    }
`;

export const Menu = styled(MuiMenu)`
    border: 1px solid #eaecf0;
    box-shadow: 0px 4px 6px -2px #10182808;
    box-shadow: 0px 12px 16px -4px #10182814;
    padding: 4px 0px 4px 0px;
    border-radius: 8px 0px 0px 0px;
    border: 1px 0px 0px 0px;
`;
